import { ChainId } from '@pancakeswap/sdk'
import { safeGetAddress } from 'utils'

export function shortenAddress(address: string, chars = 4): string {
  const parsed = safeGetAddress(address)
  if (!parsed) {
    throw Error(`Invalid 'address' parameter '${address}'.`)
  }
  return `${parsed.substring(0, chars + 2)}...${parsed.substring(42 - chars)}`
}
export function feeTierPercent(fee: number): string {
  return `${fee / 10_000}%`
}

export const currentTimestamp = () => new Date().getTime()

export function getEtherscanLink(
  chainId: ChainId,
  data: string,
  type: 'transaction' | 'token' | 'address' | 'block',
): string {


const prefix = chainId === ChainId.ZEUSCHAIN ? 'https://zeuschainscan.io': chainId === ChainId.BASE ? `https://basescan.org`: chainId === ChainId.ETHEREUM ? `https://etherscan.org`: chainId === ChainId.APOLLO ? `https://apolloscan.io`: chainId === ChainId.APECHAIN ? `https://apescan.io`: chainId === ChainId.BSC ? `https://bscscan.com`: chainId === ChainId.POLYGON ? `https://polygonscan.com` : `https://etherscan.io`


  switch (type) {
    case 'transaction': {
      return `${prefix}/tx/${data}`
    }
    case 'token': {
      return `${prefix}/token/${data}`
    }
    case 'block': {
      return `${prefix}/block/${data}`
    }
    case 'address':
    default: {
      return `${prefix}/address/${data}`
    }
  }
}
